import { render, staticRenderFns } from "./resultFrame.vue?vue&type=template&id=219ee745&scoped=true&"
import script from "./resultFrame.vue?vue&type=script&lang=js&"
export * from "./resultFrame.vue?vue&type=script&lang=js&"
import style0 from "./resultFrame.vue?vue&type=style&index=0&id=219ee745&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "219ee745",
  null
  
)

export default component.exports